/**
 * 통로등 테스트 — 사람이나 차가 지나갈 때 CCTV 마다 통로등이 밝아지는지 갱신 결과를 모아 본다.
 * CCTV 별로 지금까지 본 가장 어두운 값(평소)과 가장 밝은 값을 기억하고, 평소보다 밝아진 적이
 * 있으면 반응한 것으로 친다. 처음부터 켜져 있던 CCTV 도 한 번 어두워졌다 다시 밝아지면 잡힌다.
 */
import type { QaCctvLights } from '../../services/SiteParkingQaService';

export interface AisleCctv {
  low: number;
  high: number;
  value: number;
  /** 평소보다 밝아진 걸 처음 본 시각(ms). */
  reactedAt?: number;
}
export interface AisleEvent {
  at: number;
  cctv: string;
  from: number;
  to: number;
}
export interface AisleWatch {
  cctvs: Record<string, AisleCctv>;
  /** 최근 것이 앞. */
  events: AisleEvent[];
}

export const EMPTY_AISLE_WATCH: AisleWatch = { cctvs: {}, events: [] };
const MAX_EVENTS = 30;

/** 갱신 한 번을 합친다. 통로등이 없는 CCTV 는 세지 않는다. */
export function foldAisle(
  prev: AisleWatch,
  lights: Record<string, QaCctvLights>,
  at: number,
): AisleWatch {
  const cctvs = { ...prev.cctvs };
  const events: AisleEvent[] = [];
  Object.entries(lights).forEach(([name, l]) => {
    if (!l.aisleTotal) return;
    const v = l.aisleValue;
    const p = cctvs[name];
    if (!p) {
      cctvs[name] = { low: v, high: v, value: v };
      return;
    }
    const low = Math.min(p.low, v);
    const high = Math.max(p.high, v);
    cctvs[name] = {
      low,
      high,
      value: v,
      reactedAt: p.reactedAt ?? (high > low ? at : undefined),
    };
    if (v !== p.value) events.push({ at, cctv: name, from: p.value, to: v });
  });
  return { cctvs, events: [...events, ...prev.events].slice(0, MAX_EVENTS) };
}
